import { GlobalLogic } from '../../shared/logic/global-logic';
import { TestLogicFactory } from '../../eye-test/logic/test-logic-factory';
import { TextTestLogic } from '../../eye-test/logic/text-test-logic';
import {
    IContrastResultTelemetryData,
    IFinalTelemetryContainer,
    IMichelsonResultTelemetryData,
    ITelemetryData,
    IVisusResultTelemetryData
} from './typings';

const globalLogic = GlobalLogic.getInstance();
const eyeTestLogic = TestLogicFactory.getInstanceOf('eye-test-logic');
const contrastTestLogic = TestLogicFactory.getInstanceOf('contrast-test-logic');
const michelsonTestLogic = TestLogicFactory.getInstanceOf('michelson-test-logic');
const textTestLogic = TextTestLogic.getInstance();

export function getConfigTelemetryData(): any {
    return globalLogic.getTelemetryData();
}

export function getVisusResultTelemetryData(): ITelemetryData {
    return eyeTestLogic.getTelemetryData();
}

export function getContrastResultTelemetryData(): ITelemetryData {
    return contrastTestLogic.getTelemetryData();
}

export function getMichelsonResultTelemetryData(): ITelemetryData {
    return michelsonTestLogic.getTelemetryData();
}

export function getVergroesserungsbedarfTelemetryData(): ITelemetryData {
    return textTestLogic.getTelemetryData();
}

export function getFinalTelemetryData(): IFinalTelemetryContainer {
    return {
        general: globalLogic.getTelemetryData(),
        results: {
            visus: eyeTestLogic.getTelemetryData() as IVisusResultTelemetryData,
            contrast: contrastTestLogic.getTelemetryData() as IContrastResultTelemetryData,
            michelson: michelsonTestLogic.getTelemetryData() as IMichelsonResultTelemetryData,
            vergroesserungsbedarf: textTestLogic.getTelemetryData()
        }
    }
}
